<template>
    <div class="img-container" :class="{
        'img-container__onlyBg': onlyBg
    }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseImg',
    data () {
        const src = this.src
        return {
            path: src
        }
    },
    props: {
        src: {
            type: String,
            required: false,
            default: undefined
        },
        name: {
            type: String,
            required: false,
            default: undefined
        },
        alternative: {
            type: String,
            required: false,
            default: 'Картинка не найден!'
        },
        imgClass: {
            type: String,
            required: false,
            default: ''
        },
        onlyBg: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style>

.img-container {
    display: inline-block;
    height: 100%;
}
.img-container img {
    height: 100%;
    user-select: none;
    object-fit: cover;
    max-width: 100%;
}
.img-container__onlyBg {
    position: relative;
    overflow: hidden;
}
.img-container__onlyBg img {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 1;
}

</style>
